<template>
  <div
    v-if="healthdata"
    class="container"
  >
    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-body text-center">
            <router-link
              class="btn btn-primary"
              :to="{name: 'scorecard'}"
            >
              &lt;&lt; Back to Scorecard
            </router-link>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Your Exercise Score</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              <linear-gauge
                :show-title="false"
                :show-display-val="false"
                :show-hero-metric="true"
                :title="healthdata.scorecard.factor_groups.exercise.points"
                :value="healthdata.scorecard.factor_groups.exercise.percentage"
              />
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Fitness Level</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              Your overall fitness level is
              <strong>
                <span
                  v-if="healthdata.scorecard.factor_groups.exercise.points == 0"
                  class="text-red-dark"
                >Inactive</span>
                <span
                  v-else-if="healthdata.scorecard.factor_groups.exercise.points <= 4"
                  class="text-red"
                >Sedentary</span>
                <span
                  v-else-if="healthdata.scorecard.factor_groups.exercise.points <= 10"
                  class="text-yellow-dark"
                >Average</span>
                <span
                  v-else-if="healthdata.scorecard.factor_groups.exercise.points <= 14"
                  class="text-green-light"
                >Active</span>
                <span
                  v-else-if="healthdata.scorecard.factor_groups.exercise.points <= 18"
                  class="text-green"
                >Very Active</span>
                <span v-else>N/A</span>
              </strong>.
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Exercise Frequency</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              You exercise about {{ weeklyExcerciseFreq }} times a week, totaling around {{ healthdata.answers.exercise.duration }} minutes.
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4><i class="fa fa-shoe-prints" /> Steps</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              You take {{ formatNumber(healthdata.answers.exercise.daily_steps) }} steps daily.
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Your current Fitness SPIRAL®: {{ healthdata.scorecard.fitness_spiral.name }} Fitness SPIRAL®</h4>
          </div>
          <div class="card-body">
            <img
              v-if="healthdata.scorecard.fitness_spiral.image.path_full"
              class="card-image-top w-100 mb-2"
              data-toggle="modal"
              data-target="#fitnessSpiralModal"
              :src="healthdata.scorecard.fitness_spiral.image.path_full"
              :alt="healthdata.scorecard.food_spiral.name + ' Fitness SPIRAL®'"
            >
            <div
              id="fitnessSpiralModal"
              class="modal fade"
              tabindex="-1"
              role="dialog"
              aria-labelledby="fitnessSpiralModalLabel"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-dialog-centered modal-lg"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5
                      id="fitnessSpiralModalLabel"
                      class="modal-title"
                    >
                      {{ healthdata.scorecard.fitness_spiral.name }} Fitness SPIRAL®
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <img
                      class="w-100"
                      :src="healthdata.scorecard.fitness_spiral.image.path_full"
                      :alt="healthdata.scorecard.food_spiral.name + ' Fitness SPIRAL®'"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="card-content text-center" />
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-body text-center">
            <router-link
              class="btn btn-primary"
              :to="{name: 'scorecard'}"
            >
              &lt;&lt; Back to Scorecard
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    healthdata() {
      return this.$store.getters['healthData/current']
    },
    weeklyExcerciseFreq(){
      let freqVal = this.healthdata.answers.exercise.weekly_frequency;
      if (freqVal == '0')   return '0';
      if (freqVal == '1')   return '1';
      if (freqVal == '2-3') return '2 to 3';
      if (freqVal == '4-5') return '4 to 5';
      if (freqVal == '6-7') return '6 to 7';
    }
  },
  mounted () {
    this.$store.dispatch('healthData/GET_INITIAL_DATA');
  },
  methods: {
    formatNumber(num){
      let numberFormat = Intl.NumberFormat('en-US');
      return numberFormat.format(num);
    }
  }
}
</script>
